import FlowMode from "@/models/enums/flow-mode";

export type CreateProjectStepId =
    | "project-info"
    | "pdf-selection"
    | "building-floor-preview"
    | "creation";

export type CreateProjectStep = {
    id: CreateProjectStepId;
    title: string;
};

const commonSteps: CreateProjectStep[] = [
    {
        id: "project-info",
        title: "Informations du projet",
    },
];

const getStepsForFlowMode = (flowMode?: FlowMode): CreateProjectStep[] => {
    if (flowMode == null)
        return [];

    switch (flowMode) {
        case FlowMode._2D3DAdvanced:
            return [
                ...commonSteps,
                {
                    id: "pdf-selection",
                    title: "Fichier PDF",
                },
                {
                    id: "building-floor-preview",
                    title: "Bâtiments et étages",
                },
                {
                    id: "creation",
                    title: "Création",
                },
            ];
        case FlowMode._2D3D:
            return [
                ...commonSteps,
                {
                    id: "pdf-selection",
                    title: "Fichier PDF",
                },
                {
                    id: "creation",
                    title: "Création",
                },
            ];
        case FlowMode._3D2D:
            return [
                ...commonSteps,
                {
                    id: "creation",
                    title: "Création",
                }
            ];
        default:
            return commonSteps;
    }
};

export default getStepsForFlowMode;